module.exports = __webpack_public_path__ + "static/media/SteeringFpIImageOnlyViz90.fb7b28f6.mp4";